"use client";

import { useTheme } from "next-themes";
import { Moon, Sun } from "lucide-react";
import { cn } from "@/lib/utils";

/**
 * Icon visibility is driven by the `dark` class rather than React state, so the
 * markup is identical on server and client and there is nothing to hydrate.
 */
export function ThemeToggle({ expanded = false }: { expanded?: boolean }) {
  const { resolvedTheme, setTheme } = useTheme();

  return (
    <button
      onClick={() => setTheme(resolvedTheme === "dark" ? "light" : "dark")}
      title="Toggle theme"
      aria-label="Toggle theme"
      className={cn(
        "flex h-10 items-center gap-3 rounded-xl px-2.5 text-text-tertiary transition-colors hover:bg-scrim hover:text-text",
        !expanded && "w-10 justify-center px-0",
      )}
    >
      <Sun className="size-[18px] shrink-0 dark:hidden" />
      <Moon className="hidden size-[18px] shrink-0 dark:block" />
      {expanded && (
        <span className="truncate text-sm font-medium">
          <span className="dark:hidden">Light</span>
          <span className="hidden dark:inline">Dark</span>
        </span>
      )}
    </button>
  );
}
